module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main